import { render } from "./MiNTNewsMobile.vue?vue&type=template&id=20509058&scoped=true"
import script from "./MiNTNewsMobile.vue?vue&type=script&lang=js"
export * from "./MiNTNewsMobile.vue?vue&type=script&lang=js"

import "./MiNTNewsMobile.vue?vue&type=style&index=0&id=20509058&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20509058"]])

export default __exports__